import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

// Configurations
import Config from '@/config'

// Types
import type { CardItem, CardStore } from '@/types/helpers/store/card'

export const useCardStore = create(
	persist<CardStore>(
		set => ({
			items: [],
			price: 0,
			total: 0,
			addToCart: (inputItem: CardItem) =>
				set(state => {
					const existedItem = state.items.find(item => item.product.alias === inputItem.product.alias)

					if (existedItem) return { items: state.items.map(item => (item.product.alias === inputItem.product.alias ? inputItem : item)) }

					return { items: [...state.items, inputItem], total: state.total + 1 }
				}),
			deleteItem: (code: string) =>
				set(state => ({
					items: state.items.filter(item => item.product.code !== code),
					totasl: state.total - 1
				})),
			increaseNumberOfItem: (code: string) =>
				set(state => ({
					items: state.items.map(item => {
						if (item.product.code === code) return { ...item, ...{ numberOfItem: item.numberOfItem < item.maximum ? item.numberOfItem + 1 : item.numberOfItem } }

						return item
					})
				})),
			decreaseNumberOfItem: (code: string) =>
				set(state => ({
					items: state.items.map(item => {
						if (item.product.code === code) return { ...item, ...{ numberOfItem: item.numberOfItem > 0 ? item.numberOfItem - 1 : item.numberOfItem } }

						return item
					})
				}))
		}),
		{
			name: `${Config.shortName}-card`,
			storage: createJSONStorage(() => localStorage)
		}
	)
)
